import React from "react";


class InsuranceCustomerDashboard extends React.Component {

  render() {
    return (
      <div>Customer Dashboard Placeholder</div>
    );
  }
}

export default InsuranceCustomerDashboard;